import { render, staticRenderFns } from "./CustomerCardImage.vue?vue&type=template&id=cafa0dce&scoped=true&"
import script from "./CustomerCardImage.vue?vue&type=script&lang=js&"
export * from "./CustomerCardImage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCardImage.vue?vue&type=style&index=0&id=cafa0dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa0dce",
  null
  
)

export default component.exports